<template>
	<FormulateInput
		class="col-12 px-0 mb-3"
		type="checkbox"
		name="agreeRefuseAlumniClubLeaders"
		data-action="panels-agree-refuse-alumni-club-leaders-input"
		:validation="`${required ? 'required' : ''}`"
		:validation-messages="{
			'required': 'обязательно к заполнению',
		}"
	>
		<template #label="{ id }">
			<label :for="id" class="ml-2">
				Я понимаю и принимаю, что совет вправе отказать в рассмотрении данной заявки без объяснения причин
			</label>
		</template>
	</FormulateInput>
</template>

<script>
export default {
	name: 'AgreeRefuseAlumniClubLeadersInput',
	props: {
		required: { type: Boolean, default: false },
	},
};
</script>
